import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import { FileText, Calendar, CalendarDays } from 'lucide-react';
import { StatCard, StatCardContent, IconBox } from './reports.styles';

interface SummaryProps {
  summary?: {
    totalSent: number;
    thisMonth: number;
    thisWeek: number;
  };
  loading?: boolean;
}

const stats = [
  {
    key: 'totalSent',
    icon: FileText,
    label: 'Total Reports Sent',
    colorVariant: 'primary' as const,
  },
  {
    key: 'thisMonth',
    icon: Calendar,
    label: 'This Month',
    colorVariant: 'success' as const,
  },
  {
    key: 'thisWeek',
    icon: CalendarDays,
    label: 'This Week',
    colorVariant: 'secondary' as const,
  },
];

export function ReportHistorySummary({ summary, loading }: SummaryProps) {
  if (loading) {
    return (
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3].map((i) => (
          <Grid key={i} size={{ xs: 12, md: 4 }}>
            <StatCard variant="outlined">
              <StatCardContent>
                <Skeleton variant="rounded" width={48} height={48} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width={64} height={32} />
                  <Skeleton variant="text" width={96} />
                </Box>
              </StatCardContent>
            </StatCard>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {stats.map((stat) => {
        const Icon = stat.icon;
        const value = summary?.[stat.key as keyof typeof summary] ?? 0;

        return (
          <Grid key={stat.key} size={{ xs: 12, md: 4 }}>
            <StatCard variant="outlined">
              <StatCardContent>
                <IconBox colorVariant={stat.colorVariant}>
                  <Icon size={24} />
                </IconBox>
                <Box>
                  <Typography variant="h4" fontWeight={700} color="text.primary">
                    {value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {stat.label}
                  </Typography>
                </Box>
              </StatCardContent>
            </StatCard>
          </Grid>
        );
      })}
    </Grid>
  );
}
